<template>
  <div class="myDiv">
    <div class="apply-refund">
      <div class="applyData">
        <span>订单编号</span>
        <span>{{ postdata.SAMPLE_ORDER }}</span>
      </div>
      <div class="applyData">
        <span>开票金额</span>
        <span >￥ {{this.abs(postdata.PAY_AMOUNT) }}</span>
      </div>
    </div>
    <div class="formType">
      <p class="titlefirst">发票类型<sup> *</sup></p>
      <div class="cost_reson">
        <button
          :disabled="disabled"
          :class="invoiceIndex === index ? 'isChecked' : ' '"
          v-for="(item, index) in costinvoiceType"
          :key="index"
          @click="invoiceIndexHandle(item, index)"
        >
          {{ item.value }}
        </button>
      </div>
      <p class="title">发票内容<sup> *</sup></p>
      <div class="cost_reson">
        <button
          :disabled="disabled"
          :class="costIndex === index ? 'isChecked' : ' '"
          v-for="(item, index) in costData"
          :key="index"
          @click="costIndexHandle(item, index)"
        >
          {{ item.value }}
        </button>
      </div>
      <p class="title">发票抬头类型<sup> *</sup></p>
      <div class="cost_reson">
        <button
          :disabled="disabledhead"
          :class="typeIndex === index ? 'isChecked' : ' '"
          v-for="(item, index) in costType"
          :key="index"
          @click="typeIndexHandle(item, index)"
        >
          {{ item.value }}
        </button>
      </div>
      <template v-if="typeIndex === 0">
        <p class="title">抬头名称<sup> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.INVOICE_TITLE"
          placeholder="请填写真实姓名"
          :readonly="disabled"
        />
        <p class="title" v-show="isEmail">电子邮箱<sup> *</sup></p>
        <input
          class="inputbox"
          v-show="isEmail"
          type="text"
          v-model="postdata.EMAIL"
          :readonly="disabled"
        />
        <!-- <p class="title">提前开票原因</p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.BEFORE_INVOICE_REASON"
          :readonly="disabled"
        /> -->
        <p class="title">开票备注</p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.REMARK"
          :readonly="disabled"
        />
      </template>
      <template v-else>
        <p class="title">抬头名称<sup> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.INVOICE_TITLE"
          placeholder="请填写单位名称"
          :readonly="disabled"
        />
        <p class="title">纳税人识别号<sup v-show="xing"> *</sup></p>
        <input
          class="inputbox"
          @input="
            postdata.TAXER_NO.includes(' ') === true
              ? (ISTAXER_SHOW = true)
              : (ISTAXER_SHOW = false)
          "
          type="text"
          v-model="postdata.TAXER_NO"
          :readonly="disabled"
        />
        <p class="tips" v-if="ISTAXER_SHOW">纳税人识别号只能填写数字和字母</p>
        <p class="title">注册地址<sup v-show="xing"> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.ADDRESS_TEL"
          :readonly="disabled"
        />
        <p class="title">注册电话<sup v-show="xing"> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.TEL"
          :readonly="disabled"
        />
        <p class="title">开户银行<sup v-show="xing"> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.BANK"
          :readonly="disabled"
        />
        <p class="title">银行账号<sup v-show="xing"> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.PAY_NO"
          :readonly="disabled"
        />
        <p class="title" v-show="isEmail">电子邮箱<sup > *</sup></p>
        <input
          class="inputbox"
          v-show="isEmail"
          type="text"
          v-model="postdata.EMAIL"
          :readonly="disabled"
        />
        <!-- <p class="title">提前开票原因</p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.BEFORE_INVOICE_REASON"
          :readonly="disabled"
        /> -->
        <p class="title">开票备注</p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.REMARK"
          :readonly="disabled"
        />
      </template>
    </div>
    <div class="mailingAddress" v-if="isShow">
      <div class="mailheader">邮寄信息</div>
      <div class="mainarea"></div>
      <div class="maincontent">
        <p class="titlefirst">发票收件人姓名<sup> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.INVOICE_RECIPIENT_NAME"
          :readonly="disabled"
        />
        <p class="titlefirst">发票收件人电话<sup> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.INVOICE_RECIPIENT_PHONE"
          :readonly="disabled"
        />
        <p class="titlefirst">发票收件人地址<sup> *</sup></p>
        <input
          class="inputbox"
          type="text"
          v-model="postdata.INVOICE_RECIPIENT_ADDRESS"
          :readonly="disabled"
        />
      </div>
    </div>
    <div class="invoiceRule">
      <p>发票开具规则</p>
      <p>1）订单完成后六个月内可开具发票；</p>
      <p>2）发票开具金额为实际支付金额；</p>
      <p>3）请务必确认发票信息内容准确；</p>
    </div>
    <div class="invoiceBtn" v-show="isbtnShow">
      <span @click="saveHandle">保存</span>
      <span @click="submitHandle">提交</span>
    </div>
    <!-- <div style="width:100%;display:flex;justify-content: center;" v-if="isPop">
      <div class="showBox">
        <p>请确认发票信息，申请后不建议修改。</p>
        <div class="btns">
          <span @click="isPop=false">取消</span>
          <span @click="submitCheckHandle">确定</span>
        </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import isiOS from "../../../utils/iosAn";
import { Toast } from "vant";
import { sendRequest } from "../../../api/order";
import { el } from 'date-fns/locale';
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      price:'',
      localStorageName:'',
      localStorageEmail:'',
      newtype:0,
      name:'',
      email:'',
      ENTRUST_PERSON:'',
      istaxSubmit:'',
      xing:false,
      // 0申请开票   3保存   4审核中
      INVOICE_AUDIT_STATUS: "",
      isbtnShow: true,
      disabled: false,
      disabledhead:false,
      isPop: false,
      // 提交显示
      isOpen: '0',
      // 纳税识别号提示
      istaxNumber:'0',
      // 纳税识别号确认
      istaxNumsubmit:false,
      // 提交跳转
      toList:true,
      // 空格提示
      ISTAXER_SHOW: false,
      isShow: false,
      isEmail: true,
      invoiceIndex: 0,
      costIndex: 0,
      typeIndex: 0,
      postdata: {
        // 提前开票原因
        BEFORE_INVOICE_REASON:'',
        //主键ID
        ID:'',
        // 订单编号
        SAMPLE_ORDER: "",
        AFTER_PRICE: "",
        PAY_AMOUNT: "",
        // 发票类型
        INVOICE_TYPE: "增值税普通电子发票",
        // 发票内容
        INVOICE_CONTENT: "基因分析费",
        // 开票抬头
        INVOICE_HEADER_TYPE: "1",
        // 抬头名称
        INVOICE_TITLE: "",
        // 纳税识别号
        TAXER_NO: "",
        // 开户银行
        BANK: "",
        // 银行卡号
        PAY_NO: "",
        // 电子邮箱
        EMAIL: "",
        // 开票备注
        REMARK: "",
        // 邮寄信息
        TEL: "",
        ADDRESS_TEL: "",
        // 邮寄信息
        INVOICE_RECIPIENT_NAME: "",
        INVOICE_RECIPIENT_PHONE: "",
        INVOICE_RECIPIENT_ADDRESS: "",
      },
      costinvoiceType: [
        { id: "1", value: "增值税普通电子发票" },
        { id: "2", value: "增值税专用发票" },
      ],
      costData: [
        { id: "1", value: "基因分析费" },
        { id: "2", value: "服务费" },
      ],
      costType: [
        { id: "1", value: "个人" },
        { id: "2", value: "单位" },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    // abs(value){
    //   let a=Number(value);  //转为数字格式
    //   let b=a.toLocaleString('zh', { style: 'currency', currency: 'CNY' });
    //   return b
    // },
     // 金额 格式化
    abs(value) {  
      if (!value && value !== 0) return '';
      var intPart = Number(value) | 0; //获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{})+$)/g, '$1,'); //将整数部分逢三一断
  
      var floatPart = ".00"; //预定义小数部分
      var value2Array = value.toString().split(".");
  
      //=2表示数据有小数位
      if (value2Array.length == 2) {
          floatPart = value2Array[1].toString(); //拿到小数部分
  
          if (floatPart.length == 1) { //补0,实际上用不着
              return intPartFormat + "." + floatPart + '0';
          } else {
              return intPartFormat + "." + floatPart;
          }
      } else {
          return intPartFormat + floatPart;
      }
    },
    // 取url参数
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },

    // 发票类型
    invoiceIndexHandle(item, index) {
      this.invoiceIndex = index;
      this.postdata.INVOICE_TYPE = item.value;
      this.postdata.INVOICE_TYPE == "增值税专用发票"
        ? (this.isShow = true)
        : (this.isShow = false);
      this.postdata.INVOICE_TYPE == "增值税专用发票"
        ? (this.isEmail = false)
        : (this.isEmail = true);
      console.log(this.postdata.INVOICE_TYPE);
      if (this.postdata.INVOICE_TYPE == "增值税专用发票") {
        this.postdata.INVOICE_HEADER_TYPE = '2';
        this.typeIndex = 1;
        this.xing = true
        // if(this.postdata.INVOICE_HEADER_TYPE == '2'&&this.INVOICE_AUDIT_STATUS==0){
        //   this.postdata.INVOICE_TITLE =''
        //   this.postdata.EMAIL =''
        //   this.postdata.INVOICE_RECIPIENT_NAME = ''
        //   this.postdata.REMARK = ''
        // }
        if(this.INVOICE_AUDIT_STATUS==0){
          this.postdata.INVOICE_TITLE = ''
         }
         if(this.postdata.INVOICE_HEADER_TYPE==2){
            // this.ruleForm.INVOICE_TITLE = this.localStorageName
            if(this.newtype==2){
             this.postdata.INVOICE_TITLE =this.localStorageName 
             this.postdata.EMAIL = this.localStorageEmail
            }else{
              this.postdata.INVOICE_TITLE =''
            }
          }
      } else {
        this.xing = false
      }
      if (this.postdata.INVOICE_TYPE == "增值税普通电子发票") {
         this.disabledhead = false
      }else{
        this.disabledhead = true
      }
    },
    // 发票内容
    costIndexHandle(item, index) {
      this.costIndex = index;
      this.postdata.INVOICE_CONTENT = item.value;
      console.log(this.postdata.INVOICE_CONTENT);
    },
    // 发票抬头类型
    typeIndexHandle(item, index) {
      this.typeIndex = index;
      this.postdata.INVOICE_HEADER_TYPE = item.id;
      console.log(this.typeIndex);
      if (this.postdata.INVOICE_HEADER_TYPE=='2'&&this.postdata.INVOICE_TYPE == "增值税专用发票") {
        this.disabledhead = true
      }
      if(this.typeIndex==0){
        this.postdata.INVOICE_TITLE = this.name;
        this.postdata.EMAIL = this.email;      
        if(this.INVOICE_AUDIT_STATUS==3){                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
            if(this.newtype==1){
              this.postdata.INVOICE_TITLE =this.localStorageName 
              this.postdata.EMAIL =this.localStorageEmail
            }else{
              this.postdata.INVOICE_TITLE = this.name;
              this.postdata.EMAIL = this.localStorageEmail;
            }
          }
      }else{
        this.postdata.INVOICE_TITLE = '';
        this.postdata.EMAIL = this.email;
        if(this.INVOICE_AUDIT_STATUS==3){
          console.log(this.localStorageName,'this.localStorageName ')
          if(this.newtype==2){
            this.postdata.INVOICE_TITLE =this.localStorageName 
            this.postdata.EMAIL =this.localStorageEmail
          }else{
            this.postdata.INVOICE_TITLE =''
            this.postdata.EMAIL = this.localStorageEmail;
          }
        }
      }
    },
    // 提交 校验
    submitHandle() {
      let emailReg =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      let phoneReg = /^1[3456789]\d{9}$/;
      console.log(this.postdata.INVOICE_TITLE)
      if (this.postdata.INVOICE_TITLE == ""||this.postdata.INVOICE_TITLE == undefined ||this.postdata.INVOICE_TITLE == null) {
        Toast("请输入姓名");
        return;
      }
      if (this.postdata.INVOICE_TYPE == "增值税普通电子发票") {
        if (this.postdata.EMAIL == "") {
          Toast("请输入邮箱");
          return;
        }
        if (!emailReg.test(this.postdata.EMAIL)) {
          Toast("邮箱有误");
          return;
        }
      }
      // 申请发票抬头为个人时，默认为订单页面录入的受检者名字。
      // 仅支持修改委托人名字（如果订单有委托人），不支持其他人名字。
      // 如果订单没有委托人，只能开受检者名字的发票。系统限制填入其他姓名。
      if(this.postdata.INVOICE_HEADER_TYPE == "1"){
        console.log('个人开票')
        //  受检者本人
        if(this.ENTRUST_PERSON=='' && this.postdata.INVOICE_TITLE !=this.name){
            Toast("请填写受检者/委托人的名字开具发票");
            return
        }
        console.log(this.ENTRUST_PERSON)
        // 有委托测序者
        if(this.ENTRUST_PERSON !='' && this.name !=''){
          console.log(this.ENTRUST_PERSON,this.name,this.postdata.INVOICE_TITLE)
          if(this.postdata.INVOICE_TITLE !=this.name && this.postdata.INVOICE_TITLE !=this.ENTRUST_PERSON){
            Toast("请填写受检者/委托人的名字开具发票");
            return
          }
        }
      }
      if (this.postdata.INVOICE_TYPE == "增值税专用发票") {
        if (this.postdata.INVOICE_HEADER_TYPE == "2") {
          let reg = /^((\d{6}[0-9A-Z]{9})|([0-9A-Za-z]{2}\d{6}[0-9A-Za-z]{10,12}))$/
          if (!reg.test(this.postdata.TAXER_NO)) {
            Toast("纳税人识别号有误");
            return;
          }
          if (this.postdata.ADDRESS_TEL == "") {
            Toast("请输入注册地址");
            return;
          }
          if (this.postdata.TEL == "") {
            Toast("请输入注册电话");
            return;
          }
          if (this.postdata.BANK == "") {
            Toast("请输入开户银行");
            return;
          }
          if (this.postdata.PAY_NO == "") {
            Toast("请输入银行账号");
            return;
          }
        }
        if (this.postdata.INVOICE_RECIPIENT_NAME == "") {
          Toast("请输入发票收件人姓名");
          return;
        }
        if (!phoneReg.test(this.postdata.INVOICE_RECIPIENT_PHONE)) {
          Toast("请输入发票收件人电话有误");
          return;
        }
        if (this.postdata.INVOICE_RECIPIENT_ADDRESS == "") {
          Toast("请输入发票收件人地址");
          return;
        }
        
      }
      if (this.postdata.INVOICE_HEADER_TYPE == "2") {
         if (this.postdata.TAXER_NO === '') {
           console.log(this.istaxSubmit,'this.istaxSubmit')
          if(this.istaxSubmit=='0'){
              if (isiOS) {
                window.webkit.messageHandlers.JSCallNative.postMessage({
                isOpen: this.isOpen,
              });
            } else {
              window.android.JSCallNative(JSON.stringify({ isOpen: this.isOpen }));
            }
          }else{
            if (isiOS) {
                window.webkit.messageHandlers.JSCallNative.postMessage({
                istaxNumber: this.istaxNumber,
              });
              } else {
                window.android.JSCallNative(JSON.stringify({ istaxNumber: this.istaxNumber }));
              }
          }
        } else {
          let reg = /^((\d{6}[0-9A-Z]{9})|([0-9A-Za-z]{2}\d{6}[0-9A-Za-z]{10,12}))$/
          if (!reg.test(this.postdata.TAXER_NO)) {
            // this.ISTAXER_SHOW = true;
            Toast("纳税识别号有误");
            return;
          } else {
            // this.ISTAXER_SHOW = false;
              if (isiOS) {
                window.webkit.messageHandlers.JSCallNative.postMessage({
                isOpen: this.isOpen,
              });
              } else {
                window.android.JSCallNative(JSON.stringify({ isOpen: this.isOpen }));
              }
          }
        }
      }else{
        if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage({
          isOpen: this.isOpen,
        });
        } else {
          window.android.JSCallNative(JSON.stringify({ isOpen: this.isOpen }));
        }
      }

      
    },
    // 提交 校验通过 接口
    // submitCheckHandle() {
    //   this.isPop = false;
    // },
    // 保存 草稿 接口
    saveHandle() {
      var arr = Object.keys(this.postdata);
      if (arr.length <= 0) {
        Toast("草稿状态不能为空");
        return;
      } else {
        sendRequest({
          requestType: "POST", //接口 是 get 还是post
          url: "/invoice/save", //接口地址
          isBody: true, // 必填get传false ,post传true
          body: this.postdata, //post 接口的参数
          params: {},
        }).then((res) => {
          console.log(res);
          if (res.code === 20000) {
            Toast(res.message);
            if (isiOS) {
              window.webkit.messageHandlers.JSCallNative.postMessage({ load: 1});
            } else {
              window.android.JSCallNative(JSON.stringify({ load: 1 }));
            }
          } else {
            Toast(res.message);
          }
        });
      }
    },
    selectInvoiceByOrderCode() {
      sendRequest({
        requestType: "GET", //接口 是 get 还是post
        url: "/invoice/selectInvoiceByOrderCodeNew", //接口地址
        isBody: false, // 必填get传false ,post传true
        body: {}, //post 接口的参数
        params: { orderCode: this.postdata.SAMPLE_ORDER }, //get 接口的参数
      }).then((res) => {
        this.postdata=res.data
        this.localStorageEmail = res.data.EMAIL
        this.localStorageName = res.data.INVOICE_TITLE
        this.newtype = res.data.INVOICE_HEADER_TYPE
        this.postdata.PAY_AMOUNT = this.price;
        console.log(this.newtype,'newtype',this.postdata,res)
        this.costinvoiceType.forEach((element, index) => {
          if (element.value == this.postdata.INVOICE_TYPE) {
            this.invoiceIndexHandle(element, index);
          }
        });
        this.costData.forEach((element, index) => {
          if (element.value == this.postdata.INVOICE_CONTENT) {
            this.costIndexHandle(element, index);
          }
        });
        this.costType.forEach((element, index) => {
          if (element.id == this.postdata.INVOICE_HEADER_TYPE) {
            this.typeIndexHandle(element, index);
          }
        });
      });
    },
  },
  created() {
    // init  1.根据 INVOICE_AUDIT_STATUS发票状态：新建发票0 驳回发票2 草稿发票3  审核发票4  2.函数路径取参 return object 
    var result = this.getUrlParams(location.href);
    console.log(result);
    this.postdata.SAMPLE_ORDER = result.CUSTOMER_ORDER_CODE;
    this.INVOICE_AUDIT_STATUS = result.INVOICE_AUDIT_STATUS;
    // this.postdata.ID = result.invId
    this.price = result.AFTER_PRICE;
    this.name = result.NAME;
    this.email = result.email;
    this.ENTRUST_PERSON = result.ENTRUST_PERSON;
    if (this.INVOICE_AUDIT_STATUS == 0) {
      console.log("新建发票状态不走详情接口");
      // this.postdata.INVOICE_TITLE =this.name;
      // this.postdata.EMAIL =this.email;
      // // this.postdata.INVOICE_RECIPIENT_NAME = ''
      // this.postdata.REMARK = ''
      this.postdata.INVOICE_TITLE = this.name;
      this.postdata.EMAIL =this.email
      this.postdata.PAY_AMOUNT = this.price
    } else if (this.INVOICE_AUDIT_STATUS == 2) {
      this.selectInvoiceByOrderCode()
      console.log(this.INVOICE_AUDIT_STATUS,"驳回发票2走详情接口");
    }else if (this.INVOICE_AUDIT_STATUS == 3) {
      this.selectInvoiceByOrderCode()
    } else if (this.INVOICE_AUDIT_STATUS == 4) {
      this.selectInvoiceByOrderCode();
      this.disabled = true;
      this.disabledhead = true;
      this.isbtnShow = false;
    }
  },
  mounted() {
      window.NativeCallJS = (res) => {
      var par = JSON.parse(res);
      console.log(par,'----------')
      this.istaxSubmit = par.istaxSubmit
      //  console.log(this.istaxSubmit,'----istaxSubmit')
      //  console.log(this.isOpen,'----isOpen')
       if(par.INVOICE_AUDIT_STATUS==3){
         this.INVOICE_AUDIT_STATUS = par.INVOICE_AUDIT_STATUS
        sendRequest({
            requestType: "GET", //接口 是 get 还是post
            url: "/invoice/selectInvoiceByOrderCodeNew", //接口地址
            isBody: false, // 必填get传false ,post传true
            body: {}, //post 接口的参数
            params: { orderCode: this.postdata.SAMPLE_ORDER }, //get 接口的参数
          }).then((res) => {
            this.postdata ={};
            this.postdata=res.data
            console.log(res)
            this.localStorageEmail = res.data.EMAIL
            this.localStorageName = res.data.INVOICE_TITLE
            this.newtype = res.data.INVOICE_HEADER_TYPE
            this.postdata.PAY_AMOUNT = this.price;
            console.log(this.newtype,'newtype',this.postdata)
          });
          console.log(par.INVOICE_AUDIT_STATUS,'par.INVOICE_AUDIT_STATUS==3')
       }
       if(par.isOpen==1){
        sendRequest({
          requestType: 'POST', //接口 是 get 还是post
          url: '/invoice/submit', //接口地址
          isBody: true, // 必填get传false ,post传true
          body: this.postdata,//post 接口的参数
          params: {},
        }).then((res)=>{
            console.log(res)
            if (res.code===20000) {
              Toast(res.message)
                if (isiOS) {
                  window.webkit.messageHandlers.JSCallNative.postMessage({ toList: this.toList});
                } else {
                  window.android.JSCallNative(JSON.stringify({ toList: this.toList }));
                }
            } else {
              this.isOpen=0
              Toast(res.message)
            }
        })
      } 
    };
  },
};
</script>
<style lang="less" scoped>
::-webkit-input-placeholder {
  font-size: 15px;
  font-weight: 400;
  color: #a4a9bf;
}
.apply-refund {
  margin: 16px 16px 0px 16px;
  padding: 0px 24px 0px 24px;
  background: #f4f8fd;
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  .applyData {
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    span:nth-of-type(1) {
      color: #9095a7;
      font-size: 15px;
    }
    span:nth-of-type(2) {
      color: #2f354d;
      font-size: 15px;
    }
  }
}
.formType {
  margin: 16px 16px 0px 16px;
  padding: 0px 24px 30px 24px;
  background: #f4f8fd;
  border-radius: 10px;
  .tips {
    font-size: 12px;
    color: #ff627f;
    padding-top: 5px;
  }
  .titlefirst {
    padding-top: 20px;
    padding-bottom: 12px;
    font-size: 13px;
    sup {
      color: #ff627f;
    }
  }
  .title {
    padding-top: 24px;
    padding-bottom: 12px;
    font-size: 13px;
    sup {
      color: #ff627f;
    }
  }
  .inputbox {
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid #e3e5e8;
    background: none;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2f354d;
  }
  .cost_reson {
    width: 295px;
    height: 32px;
    background: #ebeff7;
    border-radius: 4px;
    display: flex;
    button {
      width: 50%;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      background: #ebeff7;
    }
    .isChecked {
      width: 50%;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(52, 68, 132, 0.1);
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4b84ff;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.mailingAddress {
  border-radius: 10px;
  margin: 16px 16px 0px 16px;
  background: #f4f8fd;
  .mailheader {
    height: 70px;
    line-height: 70px;
    padding-left: 24px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
  }
  .mainarea {
    width: 100%;
    height: 20px;
    background: linear-gradient(
      360deg,
      rgba(58, 74, 134, 0) 0%,
      rgba(58, 74, 134, 0.06) 100%
    );
  }
  .maincontent {
    padding: 0px 24px 30px 24px;
    .tips {
      font-size: 12px;
      color: #ff627f;
      padding-top: 5px;
    }
    .titlefirst {
      padding-top: 20px;
      padding-bottom: 12px;
      font-size: 13px;
      sup {
        color: #ff627f;
      }
    }
    .title {
      padding-top: 24px;
      padding-bottom: 12px;
      font-size: 13px;
      sup {
        color: #ff627f;
      }
    }
    .inputbox {
      width: 100%;
      padding-bottom: 10px;
      border-bottom: 1px solid #e3e5e8;
      background: none;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2f354d;
    }
  }
}
.invoiceRule {
  margin: 16px 16px 0px 16px;
  margin-bottom: 140px;
  p {
    width: 100%;
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f697d;
    line-height: 18px;
  }
}
.invoiceBtn {
  width: 100%;
  position: fixed;
  bottom: 54px;
  display: flex;
  justify-content: space-around;
  span {
    width: 157px;
    height: 44px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span:nth-of-type(1) {
    background: #ffffff;
    box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.15);
    border-radius: 22px;
    font-size: 15px;
    color: #5f697d;
  }
  span:nth-of-type(2) {
    background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
    box-shadow: 0px 6px 20px -2px rgba(75, 132, 255, 0.3);
    border-radius: 22px;
    color: #ffffff;
  }
}
.showBox {
  width: 270px;
  background: #ffffff;
  position: fixed;
  top: 30%;
  border-radius: 0.26667rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  p {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
    line-height: 22px;
    padding: 40px 0px 40px 0px;
  }
  .btns {
    display: flex;
    width: 100%;
    border-top: 1px solid #e4e4e6;
    span {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
    span:nth-of-type(1) {
      color: #5f697d;
      border-right: 1px solid #e4e4e6;
    }
    span:nth-of-type(2) {
      color: #4b84ff;
    }
  }
}
</style>